import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const IMGS = {
  hero: 'https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?w=1800&q=85&fit=crop',
  lab: 'https://images.unsplash.com/photo-1532094349884-543559b66a4a?w=1400&q=80&fit=crop',
  online: 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=1400&q=80&fit=crop',
};

const faculties = [
  {
    name: 'Faculty of Engineering & Technology',
    programs: ['Software Engineering', 'Computer Science', 'Artificial Intelligence & Data Science', 'Electrical & Electronic Engineering', 'Industrial Engineering', 'Mechanical Engineering', 'Environmental Engineering', 'Naval Architecture & Marine Engineering', 'Architecture', 'Interior Architecture'],
  },
  {
    name: 'Faculty of Economics & Business Administration',
    programs: ['Business Management', 'Global Trade & Logistics', 'Economics', 'Accounting & Finance', 'Marketing', 'Entrepreneurship & Innovation', 'Human Resource Management'],
  },
  {
    name: 'Faculty of Social Sciences & Humanities',
    programs: ['Psychology', 'Political Science & International Relations', 'Sociology', 'Philosophy', 'Legal Studies', 'Educational Sciences', 'Child Development'],
  },
  {
    name: 'Faculty of Health & Life Sciences',
    programs: ['Healthcare Administration', 'Nutrition & Dietetics', 'Biotechnology', 'Biomedical Engineering'],
  },
];

const Programs: React.FC = () => (
  <>
    <Navbar />

    <section
      className="hero"
      style={{
        padding: '90px 24px',
        backgroundImage: `linear-gradient(160deg, rgba(4,15,30,0.90) 0%, rgba(11,37,69,0.78) 100%), url(${IMGS.hero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="hero-content">
        <span className="hero-eyebrow">Academic Programs</span>
        <h1>Over 40 Programs Across Four Faculties</h1>
        <p>Available at Bachelor's, Master's, and Doctoral levels — delivered entirely online with global accessibility.</p>
      </div>
    </section>

    {/* Degree Levels */}
    <section className="section section-light">
      <div className="container">
        <span className="section-eyebrow">Degree Structure</span>
        <h2 className="section-title">Academic Degree Levels</h2>
        <div className="divider"></div>
        <p className="section-lead">UAA operates on the American credit-based system, allowing students to complete degrees with flexibility and efficiency.</p>
        <div className="feature-grid">
          {[
            { num: "Bachelor's", title: '120 – 130 Credits', desc: 'Undergraduate programs providing comprehensive foundational and advanced academic knowledge across all disciplines.' },
            { num: "Master's", title: '30 – 60 Credits', desc: 'Graduate programs focused on professional specialization, applied research, and leadership development.' },
            { num: 'Doctoral', title: '60 – 90 Credits', desc: 'Advanced research programs designed for academic scholars and senior industry professionals seeking the highest level of qualification.' },
          ].map(f => (
            <div className="feature-card" key={f.num}>
              <div className="fc-num" style={{ fontSize: '0.88rem', fontFamily: "'Segoe UI', system-ui, sans-serif", fontWeight: 700, color: 'var(--navy)', opacity: 1, letterSpacing: '0.5px' }}>{f.num} Degree</div>
              <h3 style={{ color: 'var(--gold)' }}>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Lab / Research Banner */}
    <div
      style={{
        height: 320,
        backgroundImage: `linear-gradient(90deg, rgba(11,37,69,0.92) 0%, rgba(11,37,69,0.6) 55%, rgba(11,37,69,0.15) 100%), url(${IMGS.lab})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto', width: '100%' }}>
        <span style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: '0.7rem', fontWeight: 700, letterSpacing: '2.5px', textTransform: 'uppercase', color: 'rgba(184,150,46,0.85)', display: 'block', marginBottom: 14 }}>Research & Innovation</span>
        <h2 style={{ fontFamily: "'Georgia', serif", color: '#fff', fontSize: 'clamp(1.4rem, 2.5vw, 2rem)', maxWidth: 500, lineHeight: 1.35, marginBottom: 20 }}>
          Cutting-edge research programs aligned with global industry demands.
        </h2>
        <Link to="/apply" className="btn-primary">Apply Now</Link>
      </div>
    </div>

    {/* Faculties */}
    <section className="section section-navy">
      <div className="container">
        <span className="section-eyebrow">Faculties & Departments</span>
        <h2 className="section-title">Browse Programs by Faculty</h2>
        <div className="divider"></div>
        <div className="programs-grid">
          {faculties.map(f => (
            <div className="program-card" key={f.name}>
              <div className="dept">{f.name}</div>
              <ul>
                {f.programs.map(p => <li key={p}>{p}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Online Learning Banner */}
    <div
      style={{
        height: 340,
        backgroundImage: `linear-gradient(90deg, rgba(4,15,30,0.15) 0%, rgba(4,15,30,0.7) 55%, rgba(4,15,30,0.95) 100%), url(${IMGS.online})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 24px',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ maxWidth: 460, textAlign: 'right' }}>
          <span style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", fontSize: '0.7rem', fontWeight: 700, letterSpacing: '2.5px', textTransform: 'uppercase', color: 'rgba(184,150,46,0.85)', display: 'block', marginBottom: 14 }}>100% Online</span>
          <h2 style={{ fontFamily: "'Georgia', serif", color: '#fff', fontSize: 'clamp(1.4rem, 2.5vw, 2rem)', lineHeight: 1.35, marginBottom: 20 }}>
            Study from anywhere in the world, on your own schedule.
          </h2>
          <Link to="/apply" className="btn-primary">Begin Your Application</Link>
        </div>
      </div>
    </div>

    {/* Accelerated Pathways */}
    <section className="section">
      <div className="container">
        <span className="section-eyebrow">Accelerated Study</span>
        <h2 className="section-title">Multiple Pathways to Degree Completion</h2>
        <div className="divider"></div>
        <p className="section-lead">UAA recognizes multiple forms of demonstrated prior learning and academic achievement to help students complete their degrees efficiently.</p>
        <div className="feature-grid">
          {[
            { num: '01', title: 'CLEP Examinations', desc: 'Students may earn college credits by demonstrating subject-matter mastery through standardized CLEP assessments.' },
            { num: '02', title: 'Advanced Placement Credits', desc: 'Advanced Placement (AP) course credits are recognized and applied toward UAA degree requirements.' },
            { num: '03', title: 'International Baccalaureate', desc: 'IB Diploma Programme coursework is formally recognized for academic credit equivalency at UAA.' },
            { num: '04', title: 'RPL — Professional Experience Track', desc: 'Verified professional experience, certifications, and published research are formally assessed and converted into academic credits.' },
          ].map(f => (
            <div className="feature-card" key={f.num}>
              <div className="fc-num">{f.num}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 44, textAlign: 'center' }}>
          <Link to="/apply" className="btn-primary">Submit an Application</Link>
        </div>
      </div>
    </section>

    <Footer />
  </>
);

export default Programs;
